import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import {
    GetMachineServiceType,
    GetOperationType,
    GetMarketingType,
} from '../models/_tickets';
import { GetMarketingMaterialForFilterType } from '../models/_marketingMaterial';
import { getAvailableMachinesForReplace, GetAvailableMachinesForReplaceType, getBlenders, GetBlendersType, getBoards, GetBoardsType, getDiagnosis, GetDiagnosisType, getFlavors, GetFlavorsType, getLocations, GetLocationsType, getLogJob, getLogJobById, GetLogJobByIdResponseType, GetLogJobMachineDetailResponseType, GetLogJobMachinesResponseType, GetLogJobResponseType, getMachineDetail, getMachineList, getMachineServices, getMarketingMaterials, getMarketings, getOperations, getTubeShields, GetTubeShieldsType ,getCategories, GetCategoriesType, getCupHolders, GetCupHoldersType, GetIssueReportedType, getIssueReported} from '../models/_publicCall';
import { fetchDataFromAPI } from './fetchDataFromAPI';
import { MACHINE_SERVICES } from '../../_metronic/helpers/enums';
import store from 'store2';

export const SiteVisitationSteps = {
    ON_MY_WAY: 0,
    START_WORK: 1,
    MACHINE_LIST: 2,
    TICKET_INFO: 3,
    CREATE_TICKET: 4,
    REPLACE_MACHINE: 5,
    MACHINE_INFO: 6,
    LOCATION_INFO_1: 7,
    LOCATION_INFO_2: 8,
}

export interface SiteVisitationMachine {
    id: string;
    blenderId: string | null;
    tubeShieldId: string | null;
    name: string;
    serialNumber: string;
    hasPolyfuses: boolean;
    made4Smoothies: boolean;
    cleanlinessCheck: boolean;
    getStatusPassed: boolean;
    flowmeterActivated: boolean;
    waterLevelCalibratedWithScale: boolean;
    sanitizerLevel: string;
    replaceFilter: boolean;
    replaceMachine: boolean;
    newMachineId: string;
    oldMachineShiftToLocationId?: string;
    convertToLabTicket?: boolean;
    [key: string]: any;
}

interface TicketType {
    id: string;
    name: string;
}
interface SiteVisitationContextProps {
    cupHolderDB:GetCupHoldersType[];
    machineServicesDB: GetMachineServiceType[];
    operationDB: GetOperationType[];
    marketingDB: GetMarketingType[];
    machinesDB: GetAvailableMachinesForReplaceType[];
    locationsDB: GetLocationsType[];
    blendersDB: GetBlendersType[];
    boardsDB: GetBoardsType[];
    tubeShieldsDB: GetTubeShieldsType[];
    materialDB: GetMarketingMaterialForFilterType[];
    fetchSiteVisitJobOrder: (id: string) => void;
    fetchSiteVisitJobOrderBasic: (id: string) => void;
    fetchSiteVisitJobOrderMachineList: (id: string) => void;
    fetchSiteVisitJobOrderMachineDetail: (id: string) => void;
    logJob: GetLogJobByIdResponseType | null;
    diagnosis: GetDiagnosisType[];
    flavors: GetFlavorsType[];
    issueRepotedDB: GetIssueReportedType[];
    ticketTypes: TicketType[];
    logJobBasic: GetLogJobResponseType | null;
    logJobMachineList: GetLogJobMachinesResponseType[];
    logJobMachineDetail: GetLogJobMachineDetailResponseType | null;
    loading: boolean;
    validateTickets: (
        tickets: any[],
        selectedDiagnoses: { [ticketId: string]: string[] },
        diagnosesOther: { [ticketId: string]: string },
        selectedMachineServicesDone: { [ticketId: string]: string[] },
        machineServicesDoneOther: { [ticketId: string]: string },
        replacedBlender: { [ticketId: string]: string },
        replacedBoard: { [ticketId: string]: string }
    ) => { [ticketId: string]: string };
    validateFields: (machineId: string, storedData: any) => boolean;
    setSelectedMachine: (machineId: string, jobId: string) => void;
    updateMachineData: (jobId: string, machineId: string, field: string, value: any) => void;
    selectedMachineDetails: any;
    validationErrors: { [machineId: string]: string };
    addNewTicket: (ticket: any, jobId: string) => void;
    setTicketsForJob: (jobId: string, machineId: string, tickets: any[]) => void;
    updateTicketInStore: (jobId: string, machineId: string, ticketId: string, update: any) => void;
    saveLocationFlavorPriceToStore: (jobId: string, flavorPrices: any[]) => void;
    handleUpdateLocationOperation: (jobId: string, operationId: string) => void;
    handleLocationOtherOperationChange: (jobId:string, otherOperation: string) => void;
    getJobMachines: (jobId: string) => { [machineId: string]: SiteVisitationMachine };
    selectedMachineTickets: any[],
    refetchMachineList: (jobId: string) => void;
    categoriesDB: GetCategoriesType[];
}

const SiteVisitationContext = createContext<SiteVisitationContextProps>({
    cupHolderDB:[],
    machineServicesDB: [],
    operationDB: [],
    marketingDB: [],
    materialDB: [],
    machinesDB: [],
    blendersDB: [],
    locationsDB: [],
    tubeShieldsDB: [],
    boardsDB: [],
    fetchSiteVisitJobOrder: () => { },
    fetchSiteVisitJobOrderBasic: () => { },
    fetchSiteVisitJobOrderMachineList: () => { },
    fetchSiteVisitJobOrderMachineDetail: () => { },
    logJob: null,
    diagnosis: [],
    flavors: [],
    issueRepotedDB: [],
    ticketTypes: [],
    logJobBasic: null,
    logJobMachineList: [],
    logJobMachineDetail: null,
    loading: false,
    validateTickets: () => ({}),
    validateFields: () => true,
    setSelectedMachine: () => { },
    updateMachineData: () => { },
    selectedMachineDetails: {},
    validationErrors: {},
    addNewTicket: () => { },
    setTicketsForJob: () => { },
    selectedMachineTickets: [],
    updateTicketInStore: () => { },
    saveLocationFlavorPriceToStore: () => { },
    handleUpdateLocationOperation: () => { },
    handleLocationOtherOperationChange: () => { },
    getJobMachines: () => ({}),
    refetchMachineList: () => {},
    categoriesDB: []
});

interface SiteVisitationProviderProps {
    children: ReactNode;
}

export const SiteVisitationProvider: React.FC<SiteVisitationProviderProps> = ({ children }) => {
    const [cupHolderDB, setCupHolderDB] = useState<GetCupHoldersType[]>([]);
    const [machineServicesDB, setMachineServicesDB] = useState<GetMachineServiceType[]>([]);
    const [operationDB, setOperationDB] = useState<GetOperationType[]>([]);
    const [marketingDB, setMarketingDB] = useState<GetMarketingType[]>([]);
    const [materialDB, setMaterialDB] = useState<GetMarketingMaterialForFilterType[]>([]);
    const [logJob, setLogJob] = useState<GetLogJobByIdResponseType | null>(null);
    const [logJobBasic, setLogJobBasic] = useState<GetLogJobResponseType | null>(null);
    const [logJobMachineList, setLogJobMachineList] = useState<GetLogJobMachinesResponseType[]>([]);
    const [logJobMachineDetail, setLogJobMachineDetail] = useState<GetLogJobMachineDetailResponseType | null>(null);
    const [flavors, setFlavors] = useState<GetFlavorsType[]>([]);
    const [diagnosis, setDiagnosis] = useState<GetDiagnosisType[]>([]);
    const [machinesDB, setMachinesDB] = useState<GetAvailableMachinesForReplaceType[]>([]);
    const [locationsDB, setLocationsDB] = useState<GetLocationsType[]>([]);
    const [blendersDB, setBlendersDB] = useState<GetBlendersType[]>([]);
    const [tubeShieldsDB, setTubeShieldsDB] = useState<GetTubeShieldsType[]>([]);
    const [boardsDB, setBoardsDB] = useState<GetBoardsType[]>([]);
    const [issueRepotedDB, setIssueRepotedDB] = useState<GetIssueReportedType[]>([]);
    const [validationErrors, setValidationErrors] = useState<{ [machineId: string]: string }>({});
    const [selectedMachineDetails, setSelectedMachineDetails] = useState<any>({});
    const [selectedMachineTickets, setSelectedMachineTickets] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [categoriesDB, setCategoriesDB] = useState<GetCategoriesType[]>([]);
    const ticketTypes: TicketType[] = [
        { id: "REACTIVE_MAINTANANCE", name: "Reactive Maintenance" },
        { id: "PREVENTIVE_MAINTANANCE", name: "Preventive Maintenance" },
        // { id: "MARKETING_OTHER", name: "Marketing" },
        // { id: "LAB", name: "Lab" },
    ];
    const fetchData = async () => {
        try {
            setLoading(true);

            const [cupHolderResult,machineServiceResults, operationResults, marketingResults, materialResult, machinesResult, diagnosisResult, flavorsResult, blendersResult, boardsResult, tubeShieldsResult, locationsResult, issueReportedResult,categoryResult] = await Promise.all([
                fetchDataFromAPI(getCupHolders),
                fetchDataFromAPI(getMachineServices, { id: "other", name: "Other" }),
                fetchDataFromAPI(getOperations, { id: "other", name: "Other" }),
                fetchDataFromAPI(getMarketings, { id: "other", name: "Other" }),
                fetchDataFromAPI(getMarketingMaterials),
                fetchDataFromAPI(getAvailableMachinesForReplace),
                fetchDataFromAPI(getDiagnosis),
                fetchDataFromAPI(getFlavors),
                fetchDataFromAPI(getBlenders),
                fetchDataFromAPI(getBoards),
                fetchDataFromAPI(getTubeShields),
                fetchDataFromAPI(getLocations),
                fetchDataFromAPI(getIssueReported),
                fetchDataFromAPI(getCategories)

            ]);
            const issueReportedResultOther: GetIssueReportedType[] = issueReportedResult
                ? issueReportedResult
                : [];
            issueReportedResult.push({
                id: "other",
                name: "Other",
            });
            setCupHolderDB(cupHolderResult);
            setMachineServicesDB(machineServiceResults);
            setOperationDB(operationResults);
            setMarketingDB(marketingResults);
            setMaterialDB(materialResult);
            setMachinesDB(machinesResult);
            setFlavors(flavorsResult);
            setDiagnosis(diagnosisResult);
            setBlendersDB(blendersResult);
            setBoardsDB(boardsResult);
            setTubeShieldsDB(tubeShieldsResult);
            setLocationsDB(locationsResult);
            setIssueRepotedDB(issueReportedResultOther);
            setCategoriesDB(categoryResult)
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchSiteVisitJobOrder = async (id: string) => {
        try {
            setLoading(true);
            const logJob = await getLogJobById(id);
            setLogJob(logJob)
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSiteVisitJobOrderBasic = async (id: string) => {
        try {
            setLoading(true);
            const logJobBasic = await getLogJob(id);
            setLogJobBasic(logJobBasic)
           const jobData = store.get("job_id_data") || {};
           if(jobData[id] && jobData[id].location) {
            setLoading(false);
            return;
           }
           jobData[id] = {
               ...(jobData[id] || {}),
               location: {
                   hasSmoodiRouter: logJobBasic?.location?.hasSmoodiRouter,
                   hasWifiExtender: logJobBasic?.location?.hasWifiExtender,
                   hasPressurePump: logJobBasic?.location?.hasPressurePump,
                   hasPressureTank: logJobBasic?.location?.hasPressureTank,
                   flavorPrices: logJobBasic?.flavorPrices?.map((item: any) => ({
                       flavor: item.flavor,
                          price: item.price,
                            is_active: item.isActive,
                   })) || [],
               }
           };
           store.set("job_id_data", jobData);
           setLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSiteVisitJobOrderMachineList = async (id: string) => {
        try {
            setLoading(true);
            setLogJobMachineList([]);
            const logJobMachineList: GetLogJobMachinesResponseType[] = await getMachineList(id);
            const jobData = store.get("job_id_data") || {};
            const machinesMap = logJobMachineList.reduce((acc: any, machine: any) => {
                acc[machine.id] = machine;
                return acc;
            }, {});

            if (!jobData[id]?.machines) {
                jobData[id] = {
                    ...(jobData[id] || {}),
                    machines: machinesMap,
                };
            } else {
                const existingMachines = jobData[id].machines || {};
                Object.keys(machinesMap).forEach((machineId) => {
                    existingMachines[machineId] = {
                        ...machinesMap[machineId],
                        ...existingMachines[machineId]
                    };
                });
                jobData[id] = {
                    ...(jobData[id] || {}),
                    machines: existingMachines,
                };
            }
            store.set("job_id_data", jobData);
            setLogJobMachineList(logJobMachineList)
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchSiteVisitJobOrderMachineDetail = async (id: string) => {
        try {
            const machineId = logJobMachineDetail?.tickets?.[0]?.machineId;
            if (machineId === id) return;
            setLoading(true);
            setLogJobMachineDetail(null);
            const result = await getMachineDetail(id)
            setLogJobMachineDetail(result)
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const validateTickets = (
        tickets: any[],
        selectedDiagnoses: { [ticketId: string]: string[] },
        diagnosesOther: { [ticketId: string]: string },
        selectedMachineServicesDone: { [ticketId: string]: string[] },
        machineServicesDoneOther: { [ticketId: string]: string },
        replacedBlender: { [ticketId: string]: string },
        replacedBoard: { [ticketId: string]: string }
    ): { [ticketId: string]: string } => {
        const errors: { [ticketId: string]: string } = {};

        tickets.forEach((ticket: any) => {
            if (
                selectedDiagnoses[ticket.id]?.includes("other") &&
                !diagnosesOther[ticket.id]
            ) {
                errors[ticket.id] = "Other Diagnosis is required.";
            }

            if (
                selectedMachineServicesDone[ticket.id]?.includes("other") &&
                !machineServicesDoneOther[ticket.id]
            ) {
                errors[ticket.id] = "Other Service Details are required.";
            }

            if (
                selectedMachineServicesDone[ticket.id]?.includes(
                    MACHINE_SERVICES.REPLACE_BLENDER_ASSEMBLY
                ) &&
                !replacedBlender[ticket.id]
            ) {
                errors[ticket.id] = "Blender selection is required.";
            }

            if (
                (selectedMachineServicesDone[ticket.id]?.includes(
                    MACHINE_SERVICES.UPGRADE_PCB
                ) ||
                    selectedMachineServicesDone[ticket.id]?.includes(
                        MACHINE_SERVICES.REPLACE_PCB
                    )) &&
                !replacedBoard[ticket.id]
            ) {
                errors[ticket.id] = "Board selection is required.";
            }
        });

        return errors;
    };

    const validateFields = (machineId: string, storedData: any): boolean => {
        const requiredFields = [
            { name: "sanitizerLevel", label: "Sanitizer Level" },
            { name: "blenderId", label: "Blender" },
            { name: "tubeShieldId", label: "Tube Door Shield" },
            { name: "cupHolderId", label: "Cup Holder" },
        ];

        const newErrors = requiredFields.reduce((acc: { [key: string]: string }, field) => {
            if (!storedData?.[field.name]) {
                acc[machineId] = ` ${field.label} is required`;
            }
            return acc;
        }
            , {});

        if (storedData?.replaceMachine && (!storedData?.newMachineId)) {
            newErrors[machineId] = `New Machine is required`;
        }

        if (storedData?.replaceMachine && (!storedData?.oldMachineShiftToLocationId)) {
            newErrors[machineId] = `Location to shift old machine is required`;
        }

        if (newErrors[machineId]) {
            setValidationErrors((prev) => ({
                ...prev,
                ...newErrors,
            }));
            return false;
        }

        setValidationErrors((prev) => {
            const updatedErrors = { ...prev };
            delete updatedErrors[machineId];
            return updatedErrors;
        });
        return true;
    };

    const setSelectedMachine = (machineId: string, jobId: string) => {
        const jobData = store.get("job_id_data") || {};
        const storedMachines = jobData[jobId]?.machines || {};
        const selectedMachine = storedMachines[machineId] || {};
        setSelectedMachineDetails(selectedMachine);
    };

    const updateMachineData = (jobId: string, machineId: string, field: string, value: any) => {
        const jobData = store.get("job_id_data") || {};
        const storedMachines = jobData[jobId]?.machines || {};
        const storedData = storedMachines[machineId] || {};
        const updatedMachines = {
            ...storedMachines,
            [machineId]: {
                ...storedData,
                [field]: value,
            },
        };

        jobData[jobId] = {
            ...jobData[jobId],
            machines: {
                ...jobData[jobId]?.machines,
                [machineId]: {
                    ...jobData[jobId]?.machines?.[machineId],
                    ...updatedMachines[machineId],
                },
            },
        };
        setLogJobMachineList(Object.values(jobData[jobId].machines));
        setSelectedMachineDetails(updatedMachines[machineId]);
        store.set("job_id_data", jobData);
    };

    const addNewTicket = (ticket: any, jobId: string) => {
        const jobData = store.get("job_id_data") || {};

        if (!jobData[jobId] || !Array.isArray(jobData[jobId].tickets)) {
            jobData[jobId] = {
                ...(jobData[jobId] || {}),
                tickets: [ticket],
            };
            store.set("job_id_data", jobData);
        }
        else {
            jobData[jobId].tickets.push(ticket);
            store.set("job_id_data", jobData);
        }
    };


    const setTicketsForJob = (jobId: string, machineId: string, tickets: any[]) => {
        const jobData = store.get("job_id_data") || {};
        let storeTickets = Array.isArray(jobData[jobId]?.tickets) ? jobData[jobId].tickets : [];
        let updated = false;
        if (storeTickets.length === 0 && tickets.length > 0) {
            storeTickets = tickets.map((t: any) => ({
                id: t.id,
                selectedDiagnosis: [],
                selectedOtherDiagnosis: "",
                selectedMachineServices: [],
                selectedOtherMachineServices: "",
                replacedBlender: "",
                replacedBoard: "",
                keepTicketOpen: false,
                ...t,
            }));
            updated = true;
        } else {
            tickets.forEach((t: any) => {
                if (!storeTickets.some((st: any) => st.id === t.id)) {
                    storeTickets.push({
                        id: t.id,
                        selectedDiagnosis: [],
                        selectedOtherDiagnosis: "",
                        selectedMachineServices: [],
                        selectedOtherMachineServices: "",
                        replacedBlender: "",
                        replacedBoard: "",
                        keepTicketOpen: false,
                        ...t,
                    });
                    updated = true;
                }
            });
        }

        if (updated) {
            jobData[jobId] = {
                ...(jobData[jobId] || {}),
                tickets: storeTickets,
            };
            store.set("job_id_data", jobData);
        }
        console.log("storeTickets", storeTickets);
        const machineTickets = storeTickets.filter((t: any) => t.machineId === machineId);
        console.log("machineTickets", machineTickets);
        setSelectedMachineTickets(machineTickets);
    }

    const updateTicketInStore = (jobId: string, machineId: string, ticketId: string, update: any) => {
    const jobData = store.get("job_id_data") || {};
    let storeTickets = Array.isArray(jobData[jobId]?.tickets) ? jobData[jobId].tickets : [];
    const updatedTickets = storeTickets.map((ticket: any) =>
      ticket.id === ticketId ? { ...ticket, ...update } : ticket
    );
    jobData[jobId] = {
      ...jobData[jobId],
      tickets: updatedTickets,
    };
    store.set("job_id_data", jobData);
    const machineTickets = updatedTickets.filter((t: any) => t.machineId === machineId);
    setSelectedMachineTickets(machineTickets);
  };

  const saveLocationFlavorPriceToStore = (jobId: string, flavorPrices: any[]) => {
    const jobData = store.get("job_id_data") || {};
    jobData[jobId] = {
      ...jobData[jobId],
      location: {
        ...jobData[jobId]?.location,
        flavorPrices,
      },
    };
    store.set("job_id_data", jobData);
  };

  const handleUpdateLocationOperation = (jobId: string, operationId: string) => {
      const jobData = store.get("job_id_data") || {};
      const currentSelection: string[] = jobData[jobId]?.location?.selectedOperations || [];
      let updatedSelection: string[];
      if (currentSelection.includes(operationId)) {
        updatedSelection = currentSelection.filter((id) => id !== operationId);
      } else {
        updatedSelection = [...currentSelection, operationId];
      }
      jobData[jobId] = {
        ...jobData[jobId],
        location: {
          ...jobData[jobId]?.location,
          selectedOperations: updatedSelection,
        },
      };
      store.set("job_id_data", jobData);
    };
  
    const handleLocationOtherOperationChange = (jobId:string, otherOperation: string) => {
      const jobData = store.get("job_id_data") || {};
      jobData[jobId] = {
        ...jobData[jobId],
        location: {
          ...jobData[jobId]?.location,
          operationOther: otherOperation,
        },
      };
      store.set("job_id_data", jobData);
    };

    const getJobMachines = (jobId: string) => {
        const jobData = store.get("job_id_data") || {};
        const storedMachines = jobData[jobId]?.machines || {};
        return storedMachines;
    }

    const refetchMachineList = (jobId: string) => {
        const jobData = store.get("job_id_data") || {};
        if (jobData[jobId]) {
            jobData[jobId].machines = {};
            store.set("job_id_data", jobData);
        }
        setSelectedMachineDetails({});
        setSelectedMachineTickets([]);
        fetchSiteVisitJobOrderMachineList(jobId).then(() => {})
    };

    return (
        <SiteVisitationContext.Provider value={{ loading ,cupHolderDB, categoriesDB, logJobMachineDetail, logJobMachineList, ticketTypes, logJobBasic, machineServicesDB, operationDB, marketingDB, materialDB, logJob, flavors, diagnosis, machinesDB, blendersDB, boardsDB, tubeShieldsDB, locationsDB, fetchSiteVisitJobOrder, fetchSiteVisitJobOrderBasic, fetchSiteVisitJobOrderMachineList, fetchSiteVisitJobOrderMachineDetail, issueRepotedDB, validateTickets, validateFields, validationErrors, setSelectedMachine, updateMachineData, selectedMachineDetails, addNewTicket, setTicketsForJob, selectedMachineTickets, updateTicketInStore, saveLocationFlavorPriceToStore,handleUpdateLocationOperation, handleLocationOtherOperationChange, getJobMachines, refetchMachineList }}>
            {children}
        </SiteVisitationContext.Provider>
    );
};

export const useSiteVisitation = () => useContext(SiteVisitationContext);
